import { buttonVariants } from '~/components/ui/button';
import { Link } from '@remix-run/react';
import {
  Pagination as UiPagination,
  PaginationContent,
  PaginationItem,
} from '~/components/ui/pagination';
import { ChevronLeftIcon, ChevronRightIcon } from '@radix-ui/react-icons';

interface getPagerProps {
  pathname: string;
  searchParams: URLSearchParams;
  perPage?: number;
}
interface Pager {
  pathname: string;
  paramsString: string;
  perPage: number;
  currentPage: number;
  offset: number;
}
export const getPager = ({
  pathname,
  searchParams,
  perPage = 12,
}: getPagerProps): Pager => {

  const pageParam = searchParams.get('page');
  const currentPage =
    pageParam && Number(pageParam) && parseInt(pageParam, 10) >= 0
      ? parseInt(pageParam, 10)
      : 1;

  const offset = perPage * (currentPage - 1);

  // page 以外のパラメータを文字列にする
  searchParams.delete('page');
  console.dir(searchParams.entries())
  let paramsString = Array.from(searchParams.entries())
    .map(([key, value]) =>
      value ? `${key}=${encodeURIComponent(value)}` : key,
    )
    .join('&');
  if (paramsString) {
    paramsString = `?${paramsString}`
  }

  return {
    pathname,
    paramsString,
    perPage,
    currentPage,
    offset,
  };
};

interface Props {
  total: number;
  pager: Pager;
}

export const Pagination = ({ total, pager }: Props) => {
  const pages = () => {
    const pages = [];
    const maxPage = 5;
    const totalPage = Math.ceil(total / pager.perPage);
    const current = pager.currentPage;
    let start;
    let end;

    if (totalPage <= maxPage) {
      start = 1;
      end = totalPage;
    } else {
      const maxPagesBeforeCurrentPage = Math.floor(maxPage / 2);
      const maxPagesAfterCurrentPage = Math.ceil(maxPage / 2) - 1;

      if (current <= maxPagesBeforeCurrentPage) {
        start = 1;
        end = maxPage;
      } else if (current + maxPagesAfterCurrentPage >= totalPage) {
        start = totalPage - maxPage + 1;
        end = totalPage;
      } else {
        start = current - maxPagesBeforeCurrentPage;
        end = current + maxPagesAfterCurrentPage;
      }
    }

    for (let i = start; i <= end; i++) {
      pages.push(i);
    }

    return pages;
  };

  const getHref = (page: number): string => {
    const href = `${pager.pathname}${pager.paramsString}`

    if (page <= 1) {
      return href;
    }

    if (pager.paramsString) {
      return `${href}&page=${page}`;
    }

    return `${href}?page=${page}`;
  };

  return (
    <UiPagination className='justify-start'>
      <PaginationContent className='gap-2'>
        {pager.currentPage > 1 && (
          <PaginationItem className="min-w-[74px]">
              <Link
                to={`${getHref(pager.currentPage - 1)}`}
                className={`${buttonVariants({
                  variant: 'outline',
                })} px-[18px]`}
              >
                <ChevronLeftIcon className="h-4 w-4" />
                <span>prev</span>
              </Link>
          </PaginationItem>
        )}

        {pages().map((page) => (
          <PaginationItem key={page}>
            <Link
              to={`${getHref(page)}`}
              className={`${buttonVariants({
                variant: page === pager.currentPage ? 'outline' : 'outline',
              })} px-[13px] min-w-[36px] ${page === pager.currentPage ? 'bg-black border-none text-white' : ''}`}
            >
              {page}
            </Link>
          </PaginationItem>
        ))}

        {/* <PaginationItem>
          <PaginationEllipsis />
        </PaginationItem> */}

        <PaginationItem className="min-w-[74px]">
          {pager.currentPage < total / pager.perPage && (
            <Link
              to={`${getHref(pager.currentPage + 1)}`}
              className={`${buttonVariants({
                variant: 'outline',
              })} px-[18px]`}
            >
              <ChevronRightIcon className="h-4 w-4" />
              <span>next</span>
            </Link>
          )}
        </PaginationItem>
      </PaginationContent>
    </UiPagination>
  );
};
